
<template>
 <!--back-to-top start-->
    <a id="totop" href="#top">
        <i class="fa fa-angle-up"></i>
    </a>
    <!--back-to-top end-->
  
</template>

<script>
export default {
  name: "BackToTop",
  props: { }
};
</script>


<style scoped>

</style>





   